import * as Joi from "joi";
import { Column, Entity, JoinColumn, ManyToOne } from 'typeorm';
import { GenPartial } from 'typeormgen';
import DeptChangeScene from '../dept-change-scenes/dept-change-scene.entity';
import HaChange from '../ha-changes/ha-change.entity';
import Production from '../productions/production.entity';
import Scene from '../scenes/scene.entity';

@Entity('ha_change_scenes')
export default class HaChangeScene extends DeptChangeScene {
	static tableName = 'ha_change_scenes';

	@Column('varchar')
	mobile_id: string;

	@Column('int')
	prod_id: number;

	@Column('int')
	change_id: number;

	@Column('int')
	scene_id: number;

	@Column('text')
	h_description: string;

	@ManyToOne((type) => HaChange, (haChange) => haChange.haChangeScenes)
	@JoinColumn({
		name: 'change_id',
	})
	haChange: HaChange;

	@ManyToOne((type) => Scene, (scene) => scene.haChangeScenes)
	@JoinColumn({
		name: 'scene_id',
	})
	scene: Scene;

	@ManyToOne((type) => Production, (production) => production.haChangeScenes)
	@JoinColumn({
		name: 'prod_id',
	})
	production: Production;

	static rules() {
		return {
			...DeptChangeScene.rules(),
			h_description: Joi.string().allow(null, ''),
		};
	}

	toJSON() {
		return {
			...super.toJSON(),
			h_description: this.h_description,
		};
	}

	constructor(props?: GenPartial<HaChangeScene>) {
		super(props);
	}

	get changeSceneDescription() {
		return this.h_description;
	}

	set changeSceneDescription(changeSceneDescription: string) {
		this.h_description = changeSceneDescription;
	}
}
